import { useMutation, useQueryClient } from 'react-query';
import { supabase } from '@/utils/supabase-client';

const deleteFont = async (id, user_id) => {
  const { data, error } = await supabase
    .from('fonts')
    .delete()
    .eq('id', id)
    .eq('user_id', user_id);

  if (error) {
    // console.log('deleteFont error: ' + error.message);
    throw error;
  }

  // console.log('deleteFont data', data);
  return data;
};

export default function useDeleteFont() {
  const queryClient = useQueryClient();
  const user = supabase.auth.user();

  return useMutation((font) => deleteFont(font.id, user?.id), {
    onMutate: async (editedValue) => {
      // console.log('editedValue', editedValue);

      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries(['customFonts']);

      // Snapshot the previous value
      const previousValue = queryClient.getQueryData('customFonts');

      // Optimistically update
      const updatedValue = [...previousValue];
      const removeDeleted = updatedValue.filter(
        (eachValue) => eachValue.id !== editedValue.id
      );
      queryClient.setQueryData('customFonts', removeDeleted);

      // Return a context object with the snapshotted value
      return { previousValue };
    },

    // If the mutation fails, rollback
    onError: (error, editedValue, context) => {
      queryClient.setQueryData(['customFonts'], context.previousValue);
    },

    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(['customFonts']);
    }
  });
}
